/**
 * Wire shape extendido Fiado. Aplica a TODO response del rbac (success y error).
 * REPO_SPEC v1.3 §7. DEC-002.
 */

// DEC-002: wire shape extendido Fiado para success Y error. Ver DECISIONES.md.
export interface ApiSuccessBody<T> {
    code: string;
    date: string;
    data: T;
    description?: string;
    msg?: string;
    encrypted?: boolean;
}

export interface ApiErrorBody {
    code: string;
    date: string;
    data?: unknown;
    description?: string;
    msg: string;
    encrypted?: boolean;
}

export class ApiError extends Error {
    readonly code: string;
    readonly httpStatus: number;
    readonly msg: string;
    readonly data?: unknown;
    readonly description?: string;
    readonly date: string;
    readonly encrypted: boolean;

    constructor(httpStatus: number, body: ApiErrorBody) {
        super(body.msg);
        this.name = 'ApiError';
        this.httpStatus = httpStatus;
        this.code = body.code;
        this.msg = body.msg;
        this.data = body.data;
        this.description = body.description;
        this.date = body.date;
        this.encrypted = body.encrypted === true;
    }
}

export class SessionExpiredError extends ApiError {
    constructor(body: ApiErrorBody) {
        super(401, body);
        this.name = 'SessionExpiredError';
    }
}

export async function parseErrorResponse(response: Response): Promise<ApiError> {
    let body: ApiErrorBody;
    try {
        body = (await response.json()) as ApiErrorBody;
    } catch {
        body = {
            code: 'UNKNOWN_ERROR',
            date: new Date().toISOString(),
            msg: 'Algo salió mal, intenta de nuevo',
        };
    }
    if (response.status === 401 && body.code === 'SESSION_EXPIRED') {
        return new SessionExpiredError(body);
    }
    return new ApiError(response.status, body);
}
